const __WEBPACK_NAMESPACE_OBJECT__ = require("inject-body-webpack-plugin");